<script lang="ts">
  import { Col } from 'sveltestrap';
  import Card from '../../Core/Card.svelte';
  import data from "../../../Data/BonusUi/BonusUi.json";
  import { Dummytext } from '../../../utils/Constant/Constant';
</script>
{#each data.ribbonverticaldata as ribbonItem}
  <Col sm="14" md="6" lg="4">
    <Card cardProps="ribbon-vertical-right-wrapper">
      <div slot="contentbody">
        <div class="ribbon ribbon-{ribbonItem.color} ribbon-vertical-right">
          <i class="fa fa-{ribbonItem.righticon}" />
        </div>
        <p>{Dummytext}</p>
      </div>
    </Card>
  </Col>
{/each}
